import { useStaticQuery, graphql } from "gatsby";
import { Query } from "@graphql-types";

export default function getAllRegions() {

  const { allSanityRegion }: Query = useStaticQuery(graphql`
    {
      allSanityRegion(filter:{isHidden: {ne: true}}) {
        nodes {
          iban
          title
          displayTitle
          _id
        }
      }
    }
  `)

  return { allSanityRegion }
}